import globalAxios from 'axios';
import { getEnv } from '../env/environment.js';
import { DefaultApi } from '../generated/state-api/api.js';
import { Configuration } from '../generated/state-api/configuration.js';

let stateApi;
let cartApiVersion;
const getStateApi = (stage) => {
    if (!stateApi) {
        stateApi = new DefaultApi(new Configuration({ basePath: getEnv(stage).CHECKOUT_API_BASE_PATH }), undefined, globalAxios);
    }
    return stateApi;
};
const getCartApiVersion = async (stage) => {
    if (!cartApiVersion) {
        cartApiVersion = (await getStateApi(stage).getCartApiVersion()).data?.version;
    }
    return cartApiVersion;
};

export { getCartApiVersion };
//# sourceMappingURL=stateService.js.map
